export default {
  /* Stop propagations of arrows in inputs of the forms */
  stopArrows (e) {
    switch (e.key) {
      case 'ArrowRight':
      case 'ArrowLeft':
      case 'Backspace':
      case 'Delete':
        e.stopPropagation()
        break
      case 'Escape':
        this.focusStep()
    }
  },

  focusStep () {
    this.$root.$refs.step.focus()
  },

  objectCopy (object) {
    return { ...object }
  },

  /** Navigation Steps */
  stepIndex (stepName) {
    return this.order_steps.indexOf(stepName)
  },

  previous () {
    if (this.has_previous_step) this.current_step_name = this.previous_step_name
    this.focusStep()
  },

  goTo (destination) {
    if (destination !== undefined) {
      this.current_step_name = destination
    } else if (this.has_next_step) this.current_step_name = this.next_step_name

    this.steps[this.current_step_name].visited = true
    this.focusStep()
  },

  next () {
    this.goTo()
  },

  goToLastStepAvailable () {
    this.goTo(this.last_step_available)
  },

  styleCurrentStep (stepName) {
    return stepName === this.current_step_name ? this.styles.current_step : ''
  },

  /** TEXT AREAS */
  newLine (e) {
    if (e.ctrlKey && e.key === 'Enter' && this.next_step.available) this.next()
  },

  isStepAvailable (stepName) {
    const stepValidator = !this[stepName + 'Validator'].fails
    // check the second validator
    const secondaryValidatorOfStep = (this.steps[stepName].validator === undefined) || !this[this.steps[stepName].validator + 'Validator'].fails
    return stepValidator && secondaryValidatorOfStep
  },

  /** Arrows */
  /* keyup Modal cancel order */
  cancelOrderConfirm () {
    window.location.href = this.routes.home
    return 'isRedirection'
  },

  /** Modals */
  /* Cancel modal order */
  open_model_cancel_order () {
    this.visibleModal = this.modalNames.cancellation
  },

  /*
   * Convert Date ( format: 2020-01-01) to Date ( format: Monday 01 january of 2020 )
   * */
  dateToString (date) {
    const dateStringFormat = window.moment(date).format('dddd Do MMMM YYYY')
    return dateStringFormat.charAt(0).toUpperCase() + dateStringFormat.slice(1)
  },

  /** KEY PRESSES events, allow the user to navigate between the forms */
  canAction (e) {
    switch (e.key) {
      case 'ArrowLeft':
      case 'Backspace':
        !this.has_previous_step ? this.cancelOrder() : this.previous()
        break
      case 'ArrowRight':
      case 'Enter':
        if (!this.has_next_step) {
          this.confirmOrder()
        } else if (this.isNextStepAccessible) this.next()
        break
    }
  }
}
